function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 34,
  r: 34,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#FBAA51",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 4) translate(0 21)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 8.92L5.65 0h11.214l2.65 8.92M3.01 24.116L5.65 33h11.214l2.639-8.884m3.264-9.67h1.723c.282 0 .51.24.51.536V18.2c0 .296-.228.536-.51.536h-1.723"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 16.5,
  r: 11
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.077 18.055c2.139-.654 4.461-.377 6.396.763 1.934 1.14 3.302 3.037 3.765 5.225M12.434 11.87c3.773-1.059 7.826-.53 11.218 1.463 3.392 1.992 5.826 5.276 6.738 9.086M10.738 5.776c5.423-1.453 11.218-.686 16.098 2.132 4.881 2.818 8.443 7.453 9.896 12.876",
  transform: "translate(20 4)"
})));

var SvgConnect = function SvgConnect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connect.d28630df.svg";
export { ForwardRef as ReactComponent };